import { useHotkeys } from 'react-hotkeys-hook';
import { SHORTCUTS, type ShortcutId } from './registry';

export function useShortcut(id: ShortcutId, handler: () => void) {
  const def = SHORTCUTS[id];
  useHotkeys(
    def.keys,
    (e) => {
      e.preventDefault();
      handler();
    },
    { scopes: [def.scope], enableOnFormTags: false },
  );
}
